import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import username from '../../../helpers/validationMessages/username';
import confirmPassword from '../../../helpers/validationMessages/confirmPassword';
import email from '../../../helpers/validationMessages/email';
import login from '../../../helpers/validationMessages/login';
import password from '../../../helpers/validationMessages/password';
import terms from '../../../helpers/validationMessages/terms';
import { UserService } from '../../../services/user.service';
import { Toaster } from 'ngx-toast-notifications';
import { UserDataAttributes } from '../../../models/registerUser';
import { EnvironmentInstanceService } from '../../../environment-instance.service';

interface Roles {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit {

  @Output() infoAsked = new EventEmitter<boolean>();
  @Output() registerAsked = new EventEmitter<Object>();

  private role: string;
  private hide: boolean = true;

  private submitted = false;
  public loading = false;
  private returnUrl: string;
  private error: any;

  // Toaster Params
  private title: string;
  private text: string;
  private type: any;

  private userSub: Subscription;

  public selectedRole: string;

  public userRoles: Roles[] = [];

  public userGroups: any = [];

  public selectedGroups: string[] = []

  accountDetailsForm: FormGroup;

  account_validation_messages = {
    username: username.username,
    confirmPassword: confirmPassword.confirmPassword,
    email: email.email,
    login: login.login,
    password: password.password,
    terms: terms.terms
  }

  constructor(
    private envService: EnvironmentInstanceService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private userService: UserService,
    private toaster: Toaster
  ) { }

  ngOnInit() {
    this.userRoles = this.envService.roles

    this.userGroups = this.envService.groups

    this.createForms();
  }

  createForms() {

    // user links form validations
    this.accountDetailsForm = this.fb.group({
      username: new FormControl('', Validators.compose([
        // UsernameValidator.validUsername,
        Validators.maxLength(25),
        Validators.minLength(5),
        // Validators.pattern('^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
        Validators.required
      ])),
      password: new FormControl('', Validators.compose([
        // PasswordValidator.areEqual,
        Validators.minLength(5),
        Validators.required,
        // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$')
        Validators.pattern('^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[!*@#$%^&+=]).*$')
      ])),
      email: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$")
      ])),
      role: new FormControl('', Validators.compose([
      ])),
      groups: new FormControl([] , Validators.compose([
      ]))
    })

    for (const group of this.userGroups) {
      this.accountDetailsForm.addControl(group.value, new FormControl(''));
    }
  }

  submit(value: any) {
    let username = this.accountDetailsForm.value.username;
    let password = this.accountDetailsForm.value.password;
    let email = this.accountDetailsForm.value.email;
    let role = this.accountDetailsForm.value.role;
    let groups = this.selectedGroups;


    // instantiate the model RegisterUser
    let registerObject = new UserDataAttributes()
    registerObject.data = {
      type: 'user',
      attributes: {
      user: {
        username: username,
        password: password,
        email: email,
        is_staff: false,
        role: role,
        is_active: true
      },
      groups: groups
    }
    }
    this.userSub = this.userService.register(registerObject)
      .subscribe(
        data => {
          this.loading = true;

          if (data) {
            this.title = `Status success`
            this.text = `User ${data['data']['username']} created`
            this.toaster.open({
              caption: this.title,
              text: this.text,
              type: this.type,
            });
            this.loading = false;
            this.router.navigate(['home/dashboard'])
          }
        },
        error => {
          this.error = error;
          if (Array.isArray(this.error)) {
            this.error.forEach(err => {
              this.title = `Status ${err.code}`
              this.text = err.detail
              this.type = `error`

              this.toaster.open({
                caption: this.title,
                text: this.text,
                type: this.type,
              });
            })
          } else {
            this.title = `Status error`
            this.text = this.error.detail
            this.type = `error`

            this.toaster.open({
              caption: this.title,
              text: this.text,
              type: this.type,
            });
          }

          this.loading = false;
        });
  }

  updateSelectedGroups(groupValue: string) {
    const control = this.accountDetailsForm.get(groupValue);
  
    if (control) {
      if (control.value) {
        this.selectedGroups.push(groupValue);
      } else {
        const index = this.selectedGroups.indexOf(groupValue);
        if (index > -1) {
          this.selectedGroups.splice(index, 1);
        }
      }
    }
  }

  infoShow(agreed: boolean) {
    this.infoAsked.emit(agreed);
  }

}
